// Contrato único de listagem com paginação e ordenação no servidor.
//
// Regra do projeto: TODA tabela usa isto. O cliente manda página, tamanho e
// ordenação; o servidor devolve a fatia mais o total, para a tabela conseguir
// desenhar a quantidade de páginas. A ordenação vale sobre o conjunto inteiro,
// nunca só sobre a página corrente.
import { z } from 'zod';
export const PAGE_SIZES = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 25;
export const sortDirSchema = z.enum(['asc', 'desc']);
/**
 * Query de listagem. `sort` é validado contra as colunas ordenáveis de cada
 * recurso por `listQuery()`, para o nome da coluna nunca chegar cru no SQL.
 */
export const baseListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    size: z.coerce.number().int().min(1).max(200).default(DEFAULT_PAGE_SIZE),
    dir: sortDirSchema.default('asc'),
    /** Busca livre; cada recurso decide em quais colunas aplica. */
    q: z.string().trim().max(200).optional(),
});
/**
 * Monta o schema de query de um recurso fixando as colunas ordenáveis válidas.
 *
 *   const query = listQuery(['nome', 'slug', 'criadoEm'], 'nome')
 */
export function listQuery(sortable, defaultSort) {
    return baseListQuerySchema.extend({
        sort: z.enum(sortable).default(defaultSort),
    });
}
export function listResponse(data, total, page, size) {
    return { data, total, page, size, pages: Math.max(1, Math.ceil(total / size)) };
}
